export default class EventPublisher {
  constructor(event, data) {
    this.event = event;
    this.data = data;
  }

  publish() {
    const event = new CustomEvent(this.event, { detail: this.data });
    window.dispatchEvent(event);
  }

  static publish(event, data = {}) {
    const publisher = new EventPublisher(event, data);
    publisher.publish();
  }
}
